module.exports = __webpack_public_path__ + "img/frog.34c4d082.png";